module.exports = __webpack_public_path__ + "static/media/Illus-Birthday.ad067cef.png";